/* Native disclosures work without this enhancement; desktop links are separate
   and always visible. Only move keyboard focus when a breakpoint hides it. */
(() => {
  if (customElements.get('ziqing-footer-navigation')) return;
  class ZiqingFooterNavigation extends HTMLElement {
    connectedCallback() {
      if (this.media) return;
      this.media = matchMedia('(max-width: 600px)');
      this.onBreakpoint = () => {
        const active = this.ownerDocument.activeElement;
        const group = active?.closest('.zf-nav-group');
        if (!group || !this.contains(group)) return;
        const desktop = group.querySelector('.zf-nav-desktop');
        const mobile = group.querySelector('.zf-nav-mobile');
        const from = this.media.matches ? desktop : mobile;
        const to = this.media.matches ? mobile : desktop;
        if (!from?.contains(active) || !to) return;
        const index = Array.from(from.querySelectorAll('a')).indexOf(active);
        if (this.media.matches) mobile.open = true;
        const target = index >= 0 ? to.querySelectorAll('a')[index] : to.querySelector('h2[tabindex], summary');
        // Captured links may be inside the nested social directory disclosure.
        // Open only target ancestors so keyboard focus never moves into hidden content.
        for (let ancestor = target?.parentElement; ancestor && to.contains(ancestor); ancestor = ancestor.parentElement) {
          if (ancestor.matches('details')) ancestor.open = true;
        }
        target?.focus({ preventScroll: true });
      };
      this.onToggle = event => {
        const details = event.target;
        if (!this.media.matches || !details.matches('.zf-nav-mobile') || details.open) return;
        const active = this.ownerDocument.activeElement;
        if (details.contains(active) && active !== details.querySelector('summary')) {
          details.querySelector('summary')?.focus({ preventScroll: true });
        }
      };
      this.media.addEventListener('change', this.onBreakpoint);
      this.addEventListener('toggle', this.onToggle, true);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.onBreakpoint);
      this.removeEventListener('toggle', this.onToggle, true);
      this.media = null;
    }
  }
  customElements.define('ziqing-footer-navigation', ZiqingFooterNavigation);
})();
